import {makeAutoObservable, observable} from 'mobx'

export const resizeStore: {
  twTaskRef?: HTMLElement
  intermediateTitleWidth: number
  setTwTaskRef: (el: HTMLElement) => void
} = {
  intermediateTitleWidth: 0,
  setTwTaskRef: (el: HTMLElement): void => {
    resizeStore.twTaskRef = el
  }
}

interface State {
  resizeTitle: boolean
  tasksWidth?: number
  titleWidth?: number
}

const defaultTasksWidth = 700
const defaultTitleWidth = 346

export class ResizeStore {
  state: State = {
    resizeTitle: false
  }

  constructor() {
    makeAutoObservable(
      this,
      {
        state: observable.shallow
      },
      {autoBind: true}
    )
  }

  setResizeTitle(val = true): void {
    this.state.resizeTitle = val
  }

  getTasksWidth(): number {
    if (this.state.tasksWidth) {
      return this.state.tasksWidth
    }

    const storageTasksWidth = Number(localStorage.getItem('gantt-tasks-width'))
    if (storageTasksWidth > 0) {
      this.state.tasksWidth = storageTasksWidth
      return Number(storageTasksWidth)
    }

    this.setTasksWidth(defaultTasksWidth)
    return defaultTasksWidth
  }

  setTasksWidth(width: number): void {
    this.state.tasksWidth = width
    localStorage.setItem('gantt-tasks-width', String(width))
  }

  getTitleWidth(): number {
    if (this.state.titleWidth) {
      return this.state.titleWidth
    }

    const width = Number(localStorage.getItem('gantt-title-width'))
    if (width > 0) {
      this.state.titleWidth = width
      return Number(width)
    }

    this.setTitleWidth(defaultTitleWidth)
    return defaultTitleWidth
  }

  setTitleWidth(width: number): void {
    this.state.titleWidth = width
    localStorage.setItem('gantt-title-width', String(width))
  }
}

const timelineResizeStore = new ResizeStore()
const timelineResizeState = timelineResizeStore.state
export {timelineResizeState, timelineResizeStore}
